export const CarComprehensiveEventLeadCapturedUnion = {
  event: "CarComprehensiveEventLeadCapturedUnion",
  category: "Car Comprehensive Quote Creation Flow",
  action: "Car Comprehensive Lead Captured",
  label: "/lp/new-comprehensive/"
};

export const CarTPEventLeadCapturedUnion = {
  event: "CarTPEventLeadCapturedUnion",
  category: "Car TP Quote Creation Flow",
  action: "Car TP Lead Captured",
  label: "/lp/thirdparty/"
};

export const CarComprehensiveEventMobileNumberEnteredMMV = {
  label: "lp/new-comprehensive/mmv/",
  action: "Car Comprehensive Mobile Number Entered MMV",
  event: "CarComprehensiveEventMobileNumberEnteredMMV",
  category: "Car Comprehensive MMV Flow"
};

export const CarComprehensiveEventLeadCapturedMMV = {
  label: "lp/new-comprehensive/mmv/",
  action: "Car Comprehensive Mobile Number Entered MMV",
  event: "CarComprehensiveEventLeadCapturedMMV",
  category: "Car Comprehensive MMV Flow"
};

export const CarComprehensiveEventVerifyOTP = {
  label: "otp_login/",
  action: "Car Comprehensive Verify OTP Clicked",
  event: "CarComprehensiveEventVerifyOTP",
  category: "Car Comprehensive"
};

export const CarComprehensiveEventMobileNumberEdited = {
  label: "lp/new-comprehensive/checkout/",
  action: "Car Comprehensive Mobile Number Edited",
  event: "CarComprehensiveEventMobileNumberEdited",
  category: "Car Comprehensive Post-Quote Flow",
  ls: "TRUE",
  product_state: "Proposals"
};

export const buy_now_clicked_buy_now = {
  label: "741137|15810",
  action: "Car Comprehensive Buy Now",
  event: "buy_now_clicked_buy_now",
  category: "Car Comprehensive Plans Page"
};

export const CarEventQuoteCount = {
  label: "car/quote/",
  event: "CarEventQuoteCount",
  action: "Quote page load",
  category: "Car Comprehensive Plans Page"
};

export const EventBuyPlanClicked = {
  label: "741137|15810",
  action: "Car Comprehensive Buy Plan Clicked",
  event: "EventBuyPlanClicked",
  category: "Car Comprehensive Quote Creation Flow"
};

export const CarComprehensiveEventCheckoutMakePaymentClicked = {
  label: "lp/comprehensive/checkout/",
  action: "Car Comprehensive Checkout Make Payment Clicked",
  event: "CarComprehensiveEventCheckoutMakePaymentClicked",
  category: "Car Comprehensive Post-Quote Flow"
};

// Bike events
export const BikeEventCheckoutMakePaymentClicked = {
  label: "bike/proposal/",
  action: "Checkout Make Payment Clicked",
  event: "BikeEventCheckoutMakePaymentClicked",
  category: "Bike Post-Quote Flow"
};

export const MakePaymentClickedBike = {
  label: "bike/proposal/",
  action: "Make Payment",
  event: "make_payment_clicked_bike",
  category: "Bike Checkout Page"
};

export const EventVerifyOTPClicked = {
  label: "bike/otpverify/",
  action: "Bike Verify Otp Clicked",
  event: "EventVerifyOTPClicked",
  category: "Bike Post Quote Flow"
};

export const ViewPricesClickedBike = {
  label: "bike/",
  action: "Bike MMV Selected",
  event: "view_prices_clicked_bike",
  category: "Bike Insurance"
};

export const BikeEventBuyNowClicked = {
  label: "bike/quote/",
  action: "Buy Bike Plan Clicked",
  event: "BikeEventBuyNowClicked",
  category: "Bike Quote Creation Flow"
};

export const BikeBuyNowClicked = {
  label: "bike/quote/",
  action: "Buy Now",
  event: "buy_now_clicked_bike",
  category: "Bike Plans Page"
};
